export const weightMap = {
    regular: 400,
    medium: 500,
    bold: 700,
};
